export default __webpack_public_path__ + "03ef70779f9cd22ab5e31596b657b5e9.png";